<script setup lang="ts">
  import { computed, ref } from 'vue';
  import PosUiButton from '@/components/pos-v2/ui/PosUiButton.vue';
  import PosUiChip from '@/components/pos-v2/ui/PosUiChip.vue';
  import PosUiInput from '@/components/pos-v2/ui/PosUiInput.vue';
  const props = withDefaults(
    defineProps<{ value?: string[] | null; disabled?: boolean }>(),
    { value: null, disabled: false }
  );
  const emit = defineEmits<{ (event: 'input', value: string[]): void }>();
  const presets = [
    'vip',
    'regular',
    'allergy',
    'kids',
    'mobility',
    'vegetarian',
    'risk',
  ];
  const custom = ref('');
  const values = computed(() => props.value ?? []);
  const customValues = computed(() =>
    values.value.filter((value) => !presets.includes(value))
  );
  function toggle(value: string) {
    if (props.disabled) return;
    if (values.value.includes(value))
      emit(
        'input',
        values.value.filter((tag) => tag !== value)
      );
    else if (values.value.length < 30) emit('input', [...values.value, value]);
  }
  function add() {
    const value = custom.value.trim();
    if (
      !value ||
      value.length > 64 ||
      values.value.length >= 30 ||
      props.disabled
    )
      return;
    custom.value = '';
    if (!values.value.includes(value)) emit('input', [...values.value, value]);
  }
</script>

<template>
  <div class="reservation-tags-editor">
    <div class="tag-options">
      <PosUiChip
        v-for="tag in presets"
        :key="tag"
        :active="values.includes(tag)"
        :disabled="disabled || (!values.includes(tag) && values.length >= 30)"
        @click="toggle(tag)"
        >{{ $t(`reservations.tag.${tag}`) }}</PosUiChip
      ><PosUiChip
        v-for="tag in customValues"
        :key="tag"
        active
        icon="close"
        :disabled="disabled"
        @click="toggle(tag)"
        >{{ tag }}</PosUiChip
      >
    </div>
    <div class="custom-tag">
      <PosUiInput
        v-model="custom"
        :maxlength="64"
        :disabled="disabled || values.length >= 30"
        :placeholder="$t('reservations.detail.addTag')"
        @enter="add"
      /><PosUiButton
        color="neutral"
        variant="outline"
        icon="plus"
        :aria-label="$t('reservations.detail.addTag')"
        :disabled="disabled || !custom.trim() || values.length >= 30"
        @click="add"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
  .reservation-tags-editor {
    @apply tw-flex tw-flex-col tw-gap-3;
    .tag-options {
      @apply tw-flex tw-flex-wrap tw-gap-1.5;
    }
    .custom-tag {
      @apply tw-flex tw-gap-2;
      > :first-child {
        @apply tw-min-w-0 tw-flex-1;
      }
    }
  }
</style>
